import { h } from 'preact';
import ThreekitIcons from './components/threekit-icons';

function ThreekitMenuButton({ className }) {
  const onThreekitLogoClick = () => {
    // the Threekit buttons live on the DOM (they are display:none'd),
    // so we can just query for them and click them
    document.querySelector('[data-id="arButton"]').click();
  };

  return (
    <button onClick={onThreekitLogoClick} className={className}>
      <ThreekitIcons type="threekitLogo" />
    </button>
  );
}

export default ThreekitMenuButton;
